import { Elements } from "@ts/core/Elements";
import { Utils } from "@ts/core/Utils";
import { createAudioSection } from "./create/createAudioSection";
import { createHeadingSection } from "./create/createHeadingSection";
import { createImageSection } from "./create/createImageSection";
import { createSpotifySection } from "./create/createSpotifySection";
import { createVideoSection } from "./create/createVideoSection";
import { createYoutubeSection } from "./create/createYoutubeSection";
import { createHtmlSection } from "./create/createHtmlSection";

export enum ToolState {
    Normal,
    Active,
    Disabled
}

export class AddMenu {

    private menuElement: HTMLDivElement;

    public constructor() {
        this.menuElement = document.createElement('div');
        this.menuElement.className = 'addMenu';
    }

    public get menuElementRef(): HTMLDivElement { return this.menuElement; }

    public close(): void {
        if (this.menuElement  ) {
            this.menuElement.remove();
        }
    }

    public render() {
        Elements.leftSidebar.appendChild(this.menuElement);
        const text = document.createElement('h3');
        text.innerText = 'Skapa nya avsnitt';
        this.menuElementRef.appendChild(text);

        this.add('Rubrik',
            `Skapa en ny <span class="heading-help">rubrik</h3>`,
            'heading',
            () => {
                this.requestNewSection('heading');
            });
        this.add('Text',
            'Skapa en nytt textavsnitt',
            'text', () => {
                this.requestNewSection('text');
            });
        this.add('Bild',
            'Lägg till en bild <img src="data/assets/image.png" width="48px" height="auto">',
            'image', () => {
                this.requestNewSection('image');
            });
        this.add('Ljud',
            'Lägg till en ljudfil som t.ex MP3',
            'audio', () => {
                this.requestNewSection('audio');
            });
        this.add('Video',
            'Lägg till en videofil som t.ex MP4',
            'video', () => {
                this.requestNewSection('video');
            });
        this.add('Spotify',
            'Lägg till en Spotifylåt',
            'spotify', () => {
                this.requestNewSection('spotify');
            });
        this.add('Youtube',
            'Lägg till en Youtube video',
            'youtube', () => {
                this.requestNewSection('youtube');
            });

    }

    private async requestNewSection(type: string): Promise<void> {

        switch (type) {
            case 'audio': createAudioSection(); break;
            case 'video': createVideoSection(); break;
            case 'html':
            case 'text': createHtmlSection(); break;
            case 'image': createImageSection(); break;
            case 'heading': createHeadingSection(); break;
            case 'spotify': createSpotifySection(); break;
            case 'youtube': createYoutubeSection(); break;
        }
        Elements.contentContainer.lastElementChild?.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest", });
    }

    public add(title: string, help: string, action: string, cb: () => void): void {
        const btn = document.createElement('button');
        btn.id = action;
        btn.innerText = title;
        this.menuElement.appendChild(btn);
        btn.addEventListener('click', (e: Event) => {
            e.preventDefault();
            cb();
        });
        btn.addEventListener('mouseover', (e: Event) => {
            e.preventDefault();
            Elements.help.innerHTML = btn.disabled ? '' : help;
            Elements.help.style.top = `${btn.offsetTop}px`;
            Utils.forceRefresh(Elements.help);
        });
    }

}

